import { render, staticRenderFns } from "./ShowProfile.vue?vue&type=template&id=cdb70bc0&"
import script from "./ShowProfile.vue?vue&type=script&lang=ts&"
export * from "./ShowProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports